module.exports = __webpack_public_path__ + "static/media/desktopScreenshot06.4e2cb03e.jpg";